import React from 'react';
import {
  Box,
  Typography,
  Grid
} from '@mui/material';
import { 
  CAPTION_TRANSLATION, 
  ENTER_REFERENCE_ID, 
  SELECT_CAPTION,
  CHOOSE_TARGET_LANGUAGE,
  FILE_BEING_TRANSLATED 
} from '../constants/TranslationConstants';

interface LeftSectionProps {
  step?: number;
}

const LeftSection = ({ step = 1 }: LeftSectionProps) => {
    const getStepText = () => {
      switch(step) {
        case 1: return ENTER_REFERENCE_ID;
        case 2: return SELECT_CAPTION;
        case 3: return CHOOSE_TARGET_LANGUAGE;
        case 4: return FILE_BEING_TRANSLATED;
        default: return ENTER_REFERENCE_ID;
      }
    };
    return <>
        <Grid item xs={12} md={4}>
            <Box sx={{ 
              borderRight: { xs: 'none', md: '2px solid #e0e0e0' },
              borderBottom: { xs: '2px solid #e0e0e0', md: 'none' },
              pr: { xs: 0, md: 2 },
              pb: { xs: 2, md: 0 }
            }}>
              <Typography 
                variant="h6" 
                component="h2" 
                sx={{ 
                  fontWeight: 'bold',
                  mb: 2,
                  textAlign: 'center',
                  borderBottom: '1px solid #e0e0e0',
                  pb: 1,
                  fontSize: { xs: '1.1rem', md: '1.25rem' },
                  color: 'black'
                }}
              >
                {CAPTION_TRANSLATION}
              </Typography>
              
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ 
                  lineHeight: 1.5,
                  fontSize: { xs: '0.875rem', md: '0.875rem' }
                }}
              >
                {getStepText()}
              </Typography>
            </Box>
          </Grid>
    </>
}
export default LeftSection